// extracted by mini-css-extract-plugin
export default {"quizAnimationContainer":"QuizAnimation_quizAnimationContainer__0p-hR","quizAnimation":"QuizAnimation_quizAnimation__eWI5o"};